import { configureStore, SerializedError } from "@reduxjs/toolkit";
import { api, apiServerDownCheck } from "_shared/_stores/api";
import { rootReducer } from "_shared/_stores/root-reducer";
import { documentsSignalRReduxMiddleware } from "documents/_stores/documents-signalr-redux-middleware";
import { messagesSignalRReduxMiddleware } from "messaging/_stores/_realtime/messages-signalr-redux-middleware";
import { marketplaceSearchCacheHydrationMiddleware } from "marketplace/_stores/marketplace-search-cache-hydration-middleware";
import { notificationsSignalRReduxMiddleware } from "notifications/entities/notification/store/notifications-signalr-redux-middleware";
import { proposalsSignalRReduxMiddleware } from "work/proposals/_store/proposals-signalr-redux-middleware";
import { commentsSignalRReduxMiddleware } from "work/proposals/comments/_store/realtime/comments-signalr-redux-middleware";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "./store-types";

const attorneyHubStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(messagesSignalRReduxMiddleware)
      .concat(notificationsSignalRReduxMiddleware)
      .concat(proposalsSignalRReduxMiddleware)
      .concat(commentsSignalRReduxMiddleware)
      .concat(documentsSignalRReduxMiddleware)
      .concat(marketplaceSearchCacheHydrationMiddleware)
      .concat(apiServerDownCheck)
      .concat(api.middleware),
});

export type RootState = ReturnType<typeof attorneyHubStore.getState>;

export interface StoreState<T> {
  entries: Record<string, T>;
  loading: Record<string, boolean>;
  error: Record<string, SerializedError | null>;
}

export const useAttorneyHubDispatch = () => useDispatch<AppDispatch>();
export default attorneyHubStore;
